import { SelectOption } from "core/types";

type SelectValueProps = {
  currentValue: SelectOption,
  showIcons: boolean
}

const SelectValue = (props: SelectValueProps) => {
  const { currentValue, showIcons = false } = props;

  if (!showIcons) {
    return (
      <div className="select-item current-item">
        <p>{currentValue?.label}</p>
      </div>
    );
  }

  let icon = currentValue?.icon !== "" ? currentValue?.icon : currentValue?.iconLt;
  icon += "?width=50";

  return (
    <div className="select-item current-item icons">
      <p>
        <span className="select-icon">
          <img alt={currentValue?.label} src={icon} />
        </span>
        <span className="select-item-label">{currentValue?.label}</span>
      </p>
    </div>
  );
}

export default SelectValue;